import { GameManager } from '../../managers/GameManager';
import { ScaleManager } from '../../managers/ScaleManager';
import { Button } from '../../ui/Button';
import { SceneManager } from '../../managers/SceneManager';
import { Scene } from '../../tools/Scene';
import { PauseScene } from './PauseScene';
import { HTPScene } from './HTPScene';
import { QuitScene } from './QuitScene';
import { LocalizationManager } from '../../managers/LocalizationManager';
import { GameType } from '../../models/CBNGameModel';
import { TitleScene } from './TitleScene';
import { LetteratiGameSceneModel } from '../../viewModels/LetteratiGameSceneModel';
import { HTPContainerScene } from './HTPContainerScene';
import { PreloaderUIScene } from './PreloaderUIScene';
import { IsLetter } from '../../tools/utils/string/IsLetter';
import { Fold } from '../../tools/utils/string/Fold';

export class LetteratiGameScene extends Scene{

    //Scene's ViewModel
    viewModel:LetteratiGameSceneModel;

    //Scene Components
    bg: Phaser.GameObjects.Image|null = null;

    //Quiz Components
    scoreContainer: Phaser.GameObjects.Sprite|null = null;
    scoreLabel: Phaser.GameObjects.Text|null = null;
    score: Phaser.GameObjects.Text|null = null;
    containerWhiteFx: Phaser.GameObjects.Sprite|null = null;
    scoreFxBar: Phaser.GameObjects.Sprite|null = null;
    scoreFxStar: Phaser.GameObjects.Sprite|null = null;
    roundContainer: Phaser.GameObjects.Sprite|null = null;
    roundLabel: Phaser.GameObjects.Text|null = null;
    round: Phaser.GameObjects.Text|null = null;
    lifeContainer: Phaser.GameObjects.Sprite|null = null;
    lifeLabel: Phaser.GameObjects.Text|null = null;
    lifeGroup:Phaser.GameObjects.Sprite[]|null = [];
    timerContainer: Phaser.GameObjects.Sprite|null = null;
    timerLabel2: Phaser.GameObjects.Text|null = null;
    timerCounter: Phaser.GameObjects.Text|null = null;
    pauseButton: Button|null = null;
    timerProgressBarBg:Phaser.GameObjects.Sprite|null = null;
    timerProgressBar: Phaser.GameObjects.Graphics|null = null;
    progressBarPosition:Phaser.Math.Vector2|null = null;
    progressBarWidth:number|null = null;
    progressBarHeight:number|null = null;
    progressBarValue:number = 0;
    progressBarColor:number = 0x000000;
    timerLabel:Phaser.GameObjects.Text|null = null;

    questionContainerSprite:Phaser.GameObjects.Sprite|null = null;
    questionText: Phaser.GameObjects.Text|null = null;
    missingBlankSpriteGroup:(Phaser.GameObjects.Sprite|null)[]|null = null;
    missingBlankTextGroup:(Phaser.GameObjects.Text|null)[]|null = null;
    missingBlanksPosition:Phaser.Math.Vector2|null = null;
    missingBlankWordPerLine:number = 0;
    answersPosition:Phaser.Math.Vector2|null = null;
    answersPerRow:number|null = null;
    answersXOffset:number|null = null;
    answersYOffset:number|null = null;
    choicesBg:Phaser.GameObjects.Sprite|null = null;
    answers: Array<Button> = [];
    wordTexture:string|null = null;
    correctWordTexture:string|null = null;
    wrongWordTexture:string|null = null;
    nextQuestionButton: Button|null = null;
    nextQuestionButtonPosition:Phaser.Math.Vector2|null = null;


    //View States
    timerActive:boolean = false;
    nextQuestionButtonActive:boolean = false;

    //Additive Scenes
    preloaderUIScene:PreloaderUIScene|null = null;
    pauseScene: PauseScene;
    htpScene: HTPContainerScene;

    constructor(sceneConfig,viewModel:LetteratiGameSceneModel){
        super(sceneConfig);
        this.viewModel = viewModel;
        this.gameManager = <GameManager>GameManager.instance;
        this.htpScene = new HTPContainerScene({key:'HTPContainerScene'+Math.random()},6);
        this.pauseScene = new PauseScene({key:'PauseScene'+Math.random()},6);
    }

    preload(){
        // this.preloaderUIScene = new PreloaderUIScene(this);

    }

    prescaleCreate(){

        // if(this.preloaderUIScene){
        //     this.preloaderUIScene!.group!.destroy(true);
        //     this.preloaderUIScene!.onSceneDestroy();
        // }

        //Add Additive Scenes and their event bindings
        this.scene.add('PauseScene',this.pauseScene,true);
        this.pauseScene.emitter.on('unpause',this.onUnpauseScene,this);
        this.pauseScene.emitter.on('quitquiz',this.onEndQuiz,this);
        window.addEventListener("blur", this.onPauseScene.bind(this),false);
        window.addEventListener("pagehide", this.onPauseScene.bind(this),false);
        window.addEventListener("webkitvisibilitychange", this.checkIfInterrupt.bind(this),false);
        window.addEventListener("visibilitychange", this.checkIfInterrupt.bind(this),false);

        //Put Additive scenes that are visible at start after this
        this.scene.bringToTop(undefined!);

        if(this.gameManager.cbnGameConfig!.willDisplayHTP){
            this.scene.add('HTPContainerScene',this.htpScene,true);
            this.htpScene.emitter.on('close',this.closeHTP,this);
        }
        
        //Add Scene event bindings

        //Add viewModel event bindings
        this.viewModel.emitter.on('OnTimerEnd',this.onTimerEnd,this);
        this.viewModel.emitter.on('OnGiveLetter',this.showLetterResults,this);
        this.viewModel.emitter.on('OnGiveAnswer',this.showQuestionResults,this);
        this.viewModel.emitter.on('OnQuizEnd',this.onEndQuiz,this);
        this.viewModel.emitter.on('OnTimerChanged',this.updateQuizTimer,this);

        //Holder variables
        let position;
        let labelSprite;
        let label;
        let button:Button;
        let image;
        let sprite:Phaser.GameObjects.Sprite;
        let text;
        let style;
        let group:Phaser.GameObjects.Group;
        let graphics:Phaser.GameObjects.Graphics;

        let valueStyle = { fontFamily: 'Proximanova Regular', fontSize: 26, color: '#FFFFFF', align: 'center'};

        //Add Background
        position = this.scaleManager.getRelativePosition(.5,.5);
        this.bg = this.add.image(position.x,position.y,'lan_gen_bg');
        // this.bg.visible = false;

        //Add Score
        position = this.scaleManager.getRelativePosition(0.1,0.05);
        labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
        this.scoreContainer = labelSprite;
        label = this.add.text(position.x-100,position.y,LocalizationManager.getText('SCORE'),LocalizationManager.getStyle('SCORE'));
        label.setOrigin(.5,.5);
        this.scoreLabel = label;
        this.score = this.add.text(position.x+50,position.y,this.viewModel.getCurrentScore().toString(),valueStyle);
        this.score.setOrigin(0,.5);

        if(this.gameManager.cbnGameConfig!.gameType == GameType.full){
            //Add Round
            position = this.scaleManager.getRelativePosition(0.3,0.05);
            labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
            this.roundContainer = labelSprite;
            label = this.add.text(position.x-100,position.y,LocalizationManager.getText('ROUND'),LocalizationManager.getStyle('ROUND'));
            label.setOrigin(.5,.5);
            this.roundLabel = label;
            this.round = this.add.text(position.x+50,position.y,this.viewModel.getCurrentRoundNumber().toString(),valueStyle);
            this.round.setOrigin(0,.5);

            //Add Lives
            position = this.scaleManager.getRelativePosition(0.5,0.05);
            labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
            this.lifeContainer = labelSprite;
            label = this.add.text(position.x-100,position.y,LocalizationManager.getText('LIVES'),LocalizationManager.getStyle('LIVES'));
            label.setOrigin(.5,.5);
            this.lifeLabel = label;
            for (let index = 0; index < this.viewModel.getMaxLife(); index++) {
                let life;
                life = this.add.sprite(position.x + 7.5 + index * 60 ,position.y,'gfx_life_on');
                this.lifeGroup!.push(life);
            }

            var minutes = Math.floor(Math.round(this.viewModel!.getGameTimeRemaining()) / 60);
            var seconds = Math.round(this.viewModel!.getGameTimeRemaining()) - minutes * 60;
            var timeLeft;
            if(seconds.toString().length == 1)
            {
                timeLeft = minutes + ":0" + seconds;
            }
            else timeLeft = minutes + ":" + seconds;
                

            //Add Timer
            position = this.scaleManager.getRelativePosition(0.7,0.05);
            labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
            this.timerContainer = labelSprite;
            label = this.add.text(position.x-55,position.y,LocalizationManager.getText('TIME'),LocalizationManager.getStyle('TIME'));
            label.setOrigin(.5,.5);
            this.timerLabel2 = label;
            this.timerCounter = this.add.text(position.x+10,position.y,timeLeft,valueStyle);
            this.timerCounter.setOrigin(0,.5);

            //set lives and timer to invisible if it's practice mode
            if(this.viewModel.getIsPractice()){
                this.lifeContainer!.visible = false;
                this.lifeLabel!.visible = false;
                for(let i = 0; i < this.lifeGroup!.length ; i++)
                {
                    this.lifeGroup![i].visible = false;
                }

                this.timerContainer!.visible = false;
                this.timerCounter!.visible = false;
                this.timerLabel2!.visible = false;
            }
            
        }
        else this.lifeGroup = null;

        //Add Question
        position = this.scaleManager.getRelativePosition(.5,.4);
        image = this.add.image(position.x,position.y,'lan_ctn_question');
        this.questionContainerSprite = image;
        text = this.add.text(position.x,position.y,'{{Question}}',style);
        text.setOrigin(0.5,0.5);
        this.questionText = text;

        //Add Timer
        if(this.viewModel.getIsPractice()==false){
            position = this.scaleManager.getRelativePosition(0.5,0.25);    
            this.timerProgressBarBg = this.add.sprite(position.x,position.y,'lan_timer_ctn');
            graphics = this.add.graphics({});
            this.timerProgressBar = graphics;
            graphics.clear();
            graphics.fillStyle(0x1999f1, 1);
            this.progressBarColor = 0x1999f1;
            graphics.fillRect(position.x-900, position.y-20, 1800 * this.viewModel.getTimerProgress(), 40);
            this.progressBarPosition = new Phaser.Math.Vector2(position.x-900, position.y-20);
            this.progressBarWidth = 1800;
            this.progressBarHeight = 40;
            label = this.add.text(position.x,position.y,LocalizationManager.getText('TIME'),LocalizationManager.getStyle('TIME'));
            label.setOrigin(.5,.5);
            this.timerLabel = label;
        }

        style = { fontFamily: 'Exo Medium', fontSize:64, color: '#FFFFFF',align: 'center',wordWrap: { width: 800, useAdvancedWrap: true }};
        position = this.scaleManager.getRelativePosition(0.5,1);
        sprite = this.add.sprite(position.x,position.y,'lan_choice_bg');
        sprite.setOrigin(0.5,1);
        this.choicesBg = sprite;

        //Add Answers
        this.wordTexture = 'lan_btn_word';
        this.correctWordTexture = 'lan_btn_word_correct';
        this.wrongWordTexture = 'lan_btn_word_wrong';
        let answerStrings = this.viewModel.getCurrentQuestionLetterChoiceStrings();
        this.answersPosition = this.scaleManager.getRelativePosition(0.5,0.56);
        this.answersPerRow = 2; 
        this.answersXOffset = 500;
        this.answersYOffset = 160;
        for (let index = 0; index < 4; index++) {
            //const element = answerStrings[index];
            let answerX = ((index) % this.answersPerRow) * this.answersXOffset!;
            let answerY = (Math.floor(index/this.answersPerRow)) * this.answersYOffset!;    
            
            let word = '{{A. Choice Placeholder}}';
            if(word.length >60) {
                    word = word.substring(0,60) + '...';
            }
            let answerButton = new Button(this,this.wordTexture,this.answersPosition.x + answerX -(this.answersXOffset/2),this.answersPosition.y + answerY,{text:word,style:style});
            answerButton.buttonPressedSprite = 'lan_btn_word';
            let context = {
                answer: index,
                viewModel: this.viewModel
            }
            answerButton.emitter.on('buttonup',this.viewModel.onAnswerButtonDown,context);
            this.answers.push(answerButton);
        }

        //Add Next Question Button
        position = this.scaleManager.getRelativePosition(0.5,1);
        button = new Button(this,'next_question_button',position.x-110,position.y-80);
        button.emitter.on('buttonup',this.showNextQuestion,this);
        button.buttonPressedSprite = 'next_question_button_pressed';
        button.text.setText(LocalizationManager.getText('NEXT'));
        button.text.setStyle(LocalizationManager.getStyle('NEXT'));
        this.nextQuestionButton = button;
        Phaser.Actions.SetVisible(this.nextQuestionButton!.group.getChildren(),false);
        this.input.disable(this.nextQuestionButton!.sprite);

        //Add Pause Button
        position = this.scaleManager.getRelativePosition(1,0.05);
        button = new Button(this,'pause_button',position.x-70,position.y,{});
        button.buttonHighlightSprite = 'pause_button';
        button.buttonPressedSprite = 'pause_button_pressed';
        //button.sprite.setOrigin(1,0);
        this.pauseButton = button;
        button.emitter.on('buttonup',this.onPauseScene,this);
        
        //FX
        sprite =  this.add.sprite(position.x,position.y,'gfx_container_white');
        sprite.setAlpha(0);
        this.containerWhiteFx = sprite;

        sprite =  this.add.sprite(position.x,position.y,'gfx_flare_long');
        sprite.setAlpha(0);
        this.scoreFxBar = sprite;
        
        sprite = this.add.sprite(position.x,position.y,'gfx_flare_star');
        sprite.setAlpha(0);
        this.scoreFxStar = sprite;

        this.createMissingBlanks();
        
        //Initializations
        this.viewModel.nextLetterQuestion();
        this.updateQuizView();
        this.timerActive = false;
        this.scene.pause(undefined!);

        if(this.gameManager.cbnGameConfig!.willDisplayHTP){
            this.htpScene.startOpen();
            this.gameManager.cbnGameConfig!.willDisplayHTP = false;
        }else{
            this.closeHTP();
        }
        this.input.setTopOnly(true);

         //Add Scene event bindings
         this.events.on('resize',this.onSceneResize,this);
    }

    update(timestep,dt){
        if(this.timerActive){
            this.viewModel.update(timestep,dt);
        }
    }

    reorient(landscape:boolean){

        if(this.preloaderUIScene){
            this.preloaderUIScene.reorient(landscape);
        }

        let position;
        let style;

        if(landscape){
            position = this.scaleManager.getRelativePosition(.5,.5);
            if(this.bg){
                this.bg.setPosition(position.x,position.y);
                this.bg.setTexture('lan_gen_bg');
            }
            
            if(this.scoreContainer)
            {
                position = this.scaleManager.getRelativePosition(0.1,0.05);
                this.scoreContainer!.setPosition(position.x,position.y);
                this.scoreLabel!.setPosition(position.x-55,position.y);
                this.score!.setPosition(position.x+20,position.y);
    
                this.scoreContainer!.setScale(1,1);
                this.scoreLabel!.setScale(1,1);
                this.score!.setScale(1,1);
            }


            if(this.round){
                position = this.scaleManager.getRelativePosition(0.3,0.05);
                this.roundContainer!.setPosition(position.x,position.y);
                this.roundLabel!.setPosition(position.x-55,position.y);
                this.round!.setPosition(position.x+20,position.y);

                this.roundContainer!.setScale(1,1);
                this.roundLabel!.setScale(1,1);
                this.round!.setScale(1,1);
            }
            
            if(this.lifeGroup){
                position = this.scaleManager.getRelativePosition(0.5,0.05);
                this.lifeContainer!.setPosition(position.x,position.y);
                this.lifeLabel!.setPosition(position.x-55,position.y);

                this.lifeContainer!.setScale(1,1);
                this.lifeLabel!.setScale(1,1);
                for (let index = 0; index < this.lifeGroup.length; index++) {
                    const element = this.lifeGroup[index];
                    element.setPosition(position.x + 4 + index * 35 ,position.y);
                    element.setScale(1,1);
                }
            }

            if(this.timerContainer)
            {
                position = this.scaleManager.getRelativePosition(0.7,0.05);
                this.timerContainer!.setPosition(position.x,position.y);
                this.timerLabel2!.setPosition(position.x-55,position.y);
                this.timerCounter!.setPosition(position.x + 10 ,position.y);

                this.timerContainer!.setScale(1,1);
                this.timerLabel2!.setScale(1,1);
                this.timerCounter!.setScale(1,1);
            }

            position = this.scaleManager.getRelativePosition(0.5,0.225);
            if(this.questionContainerSprite){
                this.questionContainerSprite.setPosition(position.x,position.y);
                this.questionContainerSprite.setTexture('lan_ctn_question');
            }

            if(this.questionText){
                style = { fontFamily: 'Exo Medium', fontSize:26, color: '#FFFFFF',align: 'center',wordWrap: { width: 800, useAdvancedWrap: true }};
                this.questionText.setPosition(position.x,position.y);
                this.questionText.setStyle(style);
            }

            position = this.scaleManager.getRelativePosition(0.5,0.6);
            this.missingBlanksPosition = position;
            this.missingBlankWordPerLine = 10;
            this.layoutMissingBlanks();

            position = this.scaleManager.getRelativePosition(0.5,0.775);    
            if(this.timerProgressBarBg){
                this.timerProgressBarBg.setPosition(position.x,position.y);
                this.timerProgressBarBg.setTexture('lan_timer_ctn');
                this.progressBarWidth = 960;
                this.progressBarHeight = 20;
                this.progressBarPosition = new Phaser.Math.Vector2(position.x-(this.progressBarWidth/2), position.y);
                
                this.timerLabel!.setPosition(position.x,position.y);
                this.updateProgressBar(this.progressBarValue);
            }

            
            position = this.scaleManager.getRelativePosition(0.5,0.9);
            this.answersPerRow = 4;
            this.answersXOffset = (this.scaleManager.baseWidth!)/4.6;
            this.answersYOffset = 90;
            this.answersPosition = position;

            if(this.choicesBg){
                this.choicesBg.setTexture('lan_choice_bg');
                this.choicesBg.setPosition(position.x,position.y);
                this.choicesBg.setOrigin(0.5,0.5);
            }

            style = { fontFamily: 'Exo Medium', fontSize:64, color: '#FFFFFF',align: 'center'};
            for (let index = 0; index < this.answers.length; index++) {
                const element = this.answers[index];
                let answerX = ((index) % this.answersPerRow!) * this.answersXOffset! - ((this.answersPerRow-1) * this.answersXOffset/2);
                let answerY = (Math.floor(index/this.answersPerRow!)) * this.answersYOffset!  - ((Math.floor(index/this.answersPerRow!)) * this.answersYOffset/2);  
                let texture = element.sprite.texture.key == 'por_btn_word' ? 'lan_btn_word' : 
                element.sprite.texture.key == 'por_btn_word_correct' ? 'lan_btn_word_correct' : 
                element.sprite.texture.key == 'por_btn_word_wrong' ? 'lan_btn_word_wrong' : 'lan_btn_word';
                element.sprite.setTexture(texture);
                if(element.sprite.input.enabled){
                    this.input.setHitAreaFromTexture(element!.sprite,undefined);
                }
                element.buttonSprite = 'lan_btn_word';
                element.buttonPressedSprite = 'lan_btn_word';
                element.text.setStyle(style);
                Phaser.Actions.SetXY(element.group.getChildren(),this.answersPosition!.x + answerX ,this.answersPosition!.y + answerY);
            }

            this.wordTexture = 'lan_btn_word';
            this.correctWordTexture = 'lan_btn_word_correct';
            this.wrongWordTexture = 'lan_btn_word_wrong';

            if(this.nextQuestionButton)
            {
                Phaser.Actions.SetXY(this.nextQuestionButton!.group.getChildren(),position.x,position.y);
                this.nextQuestionButtonPosition = position;
    
                position = this.scaleManager.getRelativePosition(1,0.05);
                Phaser.Actions.SetXY(this.pauseButton!.group.getChildren(),position.x-50,position.y);
            }
            
        }else{
            position = this.scaleManager.getRelativePosition(.5,.5);

            if(this.bg)
            {
                this.bg!.setPosition(position.x,position.y);
                this.bg!.setTexture('por_gen_bg');
            }
            
            if(this.scoreContainer){
                position = this.scaleManager.getRelativePosition(0.125,0.05);
                this.scoreContainer!.setPosition(position.x,position.y);
                this.scoreLabel!.setPosition(position.x-40,position.y);
                this.score!.setPosition(position.x+20,position.y);
          
                this.scoreContainer!.setScale(0.75,0.75);
                this.scoreLabel!.setScale(0.75,0.75);
                this.score!.setScale(0.75,0.75);
            }
            
    
            if(this.round){
                position = this.scaleManager.getRelativePosition(0.345,0.05);
                this.roundContainer!.setPosition(position.x,position.y);
                this.roundLabel!.setPosition(position.x-40,position.y);
                this.round!.setPosition(position.x+20,position.y);
    
                this.roundContainer!.setScale(0.75,0.75);
                this.roundLabel!.setScale(0.75,0.75);
                this.round!.setScale(0.75,0.75);
            }
            
            if(this.lifeGroup){
                position = this.scaleManager.getRelativePosition(0.56,0.05);
                this.lifeContainer!.setPosition(position.x,position.y);
                this.lifeLabel!.setPosition(position.x-40,position.y);
    
                this.lifeContainer!.setScale(0.75,0.75);
                this.lifeLabel!.setScale(0.75,0.75);
    
                for (let index = 0; index < this.lifeGroup.length; index++) {
                    const element = this.lifeGroup[index];
                    element.setPosition(position.x + 4 + index * 25 ,position.y);
                    element.setScale(0.75,0.75);
                }
            }

            if(this.timerContainer)
            {
                position = this.scaleManager.getRelativePosition(0.775,0.05);
                this.timerContainer!.setPosition(position.x,position.y);
                this.timerLabel2!.setPosition(position.x-40,position.y);
                this.timerCounter!.setPosition(position.x + 10 ,position.y);

                this.timerContainer!.setScale(0.75,0.75);
                this.timerLabel2!.setScale(0.75,0.75);
                this.timerCounter!.setScale(0.75,0.75);
            }

            position = this.scaleManager.getRelativePosition(0.5,0.225);
            if(this.questionContainerSprite){
                this.questionContainerSprite.setPosition(position.x,position.y);
                this.questionContainerSprite.setTexture('por_ctn_question');
            }
            if(this.questionText){
                style = { fontFamily: 'Exo Medium', fontSize:26, color: '#FFFFFF',align: 'center',wordWrap: { width: 600, useAdvancedWrap: true }};
                this.questionText.setPosition(position.x,position.y);
                this.questionText.setStyle(style);
            }

            position = this.scaleManager.getRelativePosition(0.5,0.625);
            this.missingBlanksPosition = position;
            this.missingBlankWordPerLine = 6;
            this.layoutMissingBlanks();

            position = this.scaleManager.getRelativePosition(0.5,0.825);    
            if(this.timerProgressBarBg){
                this.timerProgressBarBg.setPosition(position.x,position.y);
                this.timerProgressBarBg.setTexture('por_timer_ctn');
                this.progressBarWidth = 600;
                this.progressBarHeight = 20;
                this.progressBarPosition = new Phaser.Math.Vector2(position.x-(this.progressBarWidth/2), position.y);
                this.timerLabel!.setPosition(position.x,position.y);
                this.updateProgressBar(this.progressBarValue);
            }

            position = this.scaleManager.getRelativePosition(0.5,0.925);
            this.answersPerRow = 4;
            this.answersXOffset = (this.scaleManager.baseHeight!)/4;
            this.answersYOffset = 110;
            this.answersPosition = position;

            if(this.choicesBg){
                this.choicesBg.setTexture('por_choice_bg');
                this.choicesBg.setPosition(position.x,position.y);
                this.choicesBg.setOrigin(0.5,0.5);
            }

            style = { fontFamily: 'Exo Medium', fontSize:32, color: '#FFFFFF',align: 'center',wordWrap: { width: 500, useAdvancedWrap: true }};
            for (let index = 0; index < this.answers.length; index++) {
                const element = this.answers[index];
                let answerX = ((index) % this.answersPerRow!) * this.answersXOffset - ((this.answersPerRow-1) * this.answersXOffset/2);
                let answerY = (Math.floor(index/this.answersPerRow!)) * this.answersYOffset - ((Math.floor(index/this.answersPerRow!)) * this.answersYOffset/2);
                let texture = element.sprite.texture.key == 'lan_btn_word' ? 'por_btn_word' : 
                element.sprite.texture.key == 'lan_btn_word_correct' ? 'por_btn_word_correct' :  
                element.sprite.texture.key == 'lan_btn_word_wrong' ? 'por_btn_word_wrong' : 'por_btn_word';
                element.sprite.setTexture(texture);
                element.buttonSprite = 'por_btn_word';
                element.buttonPressedSprite = 'por_btn_word';
                if(element.sprite.input.enabled){
                    this.input.setHitAreaFromTexture(element!.sprite,undefined);
                }
                element.text.setStyle(style);
                Phaser.Actions.SetXY(element.group.getChildren(),this.answersPosition!.x + answerX,this.answersPosition!.y);
            }
            this.wordTexture = 'por_btn_word';
            this.correctWordTexture = 'por_btn_word_correct';
            this.wrongWordTexture = 'por_btn_word_wrong';

            if(this.nextQuestionButton)
            {
                Phaser.Actions.SetXY(this.nextQuestionButton!.group.getChildren(),position.x,position.y);
                this.nextQuestionButtonPosition = position;
    
                position = this.scaleManager.getRelativePosition(1,0.05);
                Phaser.Actions.SetXY(this.pauseButton!.group.getChildren(),position.x-50,position.y);
            }
            
        }

        this.rescaleBackground();
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scaleManager.getRatio();

        if(this.bg!.width * this.bg!.scaleX != window.innerWidth || this.bg!.height * this.bg!.scaleY != window.innerHeight)
        {
            this.bg!.setScale(this.sys.canvas.width/this.bg!.width / ratio! , this.sys.canvas.height/this.bg!.height / ratio!);
        }
    }

    onSceneResize(event:Phaser.Scene):void {
        this.rescaleBackground();
    }

    onTimerEnd(){
        this.sound.play('ding');
        if(this.timerProgressBar){
            if(Math.round(this.viewModel.getTimerProgress()* 100)/100 < 0.01){
                this.timerProgressBar.setVisible(false);
                  
            }
        }
        this.showQuestionResults();
    }

    closeHTP(){
        this.gameManager.cbnGameConfig!.willDisplayHTP = false;
        this.timerActive = true;
        this.scene.resume(undefined!);
    }

    showLetterResults(){
        this.updateMissingBlanks();
        let result:boolean = this.viewModel.isCurrentChoiceCorrect();
        if(result){
            this.sound.play('correct');
            let answer = this.viewModel.getCurrentQuestionAnswerString();
            for (let index = 0; index < answer.length; index++) {
                const element = answer[index];
                if(element.toLowerCase() == this.answers[this.viewModel.getCurrentAnswer()].text.text.toLowerCase()){
                    
                    if(this.missingBlankSpriteGroup && this.missingBlankSpriteGroup[index]){
                        let depth = this.missingBlankSpriteGroup[index]!.depth;
                        (<any>this.children).bringToTop(this.missingBlankSpriteGroup[index]!);
                        this.tweens.add({
                            targets: this.missingBlankSpriteGroup[index],
                            scaleX: '*=2',
                            scaleY: '*=2',
                            duration: 200,
                            ease: 'Power2',
                            yoyo:true,
                            onComplete: function(tween, targets:Phaser.GameObjects.Sprite){
                                if(targets[0]){
                                    try{
                                        targets[0].setDepth(depth);
                                    }catch(err){
                                        //console.error(err);
                                    }
                                }
                            }
                        });
                    }
                    if(this.missingBlankTextGroup && this.missingBlankTextGroup[index]){
                        let depth = this.missingBlankTextGroup[index]!.depth;
                        (<any>this.children).bringToTop(this.missingBlankTextGroup[index]!);
                        this.tweens.add({
                            targets: this.missingBlankTextGroup[index],
                            scaleX: '*=2',
                            scaleY: '*=2',
                            duration: 200,
                            ease: 'Power2',
                            yoyo:true,
                            onComplete: function(tween, targets:Phaser.GameObjects.Sprite){
                                if(targets[0]){
                                    try{
                                        targets[0].setDepth(depth);
                                    }catch(err){
                                        //console.warn(err);
                                    }
                                }
                            }
                        });
                    }
                    
                }
            }

            this.viewModel.nextLetterQuestion();
            this.updateChoices();

        }else{
            this.sound.play('wrong');
            this.progressBarColor = 0xea3142;
            this.tweens.add({
                targets: this,
                progressBarHeight: '+= 20',
                progressBarWidth: '+= 20',
                duration: 100,
                yoyo: true,
                onComplete: function (tween,target:LetteratiGameScene) { 
                    //console.log('onComplete'); 
                    target[0].progressBarColor = 0x1999f1; 
                    target[0].progressBarHeight = 20;
                    //console.log(target.progressBarColor);
                    //console.log(arguments);
                },
            });
            if(this.timerLabel){
                this.tweens.add({
                    targets: this.timerLabel,
                    scaleX:1.5,
                    scaleY:1.5,
                    duration: 100,
                    yoyo: true,
                });
            }

            if(!this.viewModel.getIsPractice())
            {
                this.viewModel.nextLetterQuestion();
                this.updateChoices();
            }
            else
            {
                for(let i = 0; i< this.answers.length; i++)
                {
                    this.answers[i].sprite.setTexture(this.wrongWordTexture!);
                    this.time.delayedCall(120, ()=>{
                        this.answers[i].sprite.setTexture(this.wordTexture!);
                    }, [], this);
                }
                
                this.viewModel.nextLetterQuestion();
                this.updateChoices();

            }
            
        }

    }

    showQuestionResults(){
        if(this.score){
            this.score.setText(this.viewModel.getCurrentScore().toString());
        }
        this.updateLives();
        this.timerActive = false;
        let result:boolean = this.viewModel.isCurrentChoiceCorrect();

        this.updateMissingBlanks(true);

        //Update Choices
        if(this.answers){
            for (let index = 0; index < this.answers.length; index++) {
                const element:Button = this.answers[index];
                let word = this.viewModel.getCurrentQuestionLetterChoiceStrings()[index];
                if(result){
                    element.sprite.setTexture(this.correctWordTexture!);
                }else {
                    if(this.viewModel.getCurrentAnswer()==index){
                        element.sprite.setTexture(this.wrongWordTexture!);
                    }
                }
                Phaser.Actions.SetVisible(element.group.getChildren(),false);
                this.input.disable(element.sprite);
            }
        }

        
        
        if(result){
        this.sound.play('correct');
        //Play Score Animation FX
        if(this.scoreContainer){
            if(this.scoreFxBar && this.scoreFxStar && this.containerWhiteFx){
                this.scoreFxBar.setPosition(this.scoreContainer.x,this.scoreContainer.y);
                this.containerWhiteFx.setPosition(this.scoreContainer.x,this.scoreContainer.y);
                this.scoreFxStar.setPosition(this.scoreContainer.x - (this.scoreContainer.width/2),this.scoreContainer.y);
                this.scoreFxBar.setAlpha(0);
                this.tweens.add({
                    targets: [this.scoreFxBar,this.scoreFxStar,this.containerWhiteFx],
                    alpha: 1,
                    duration: 500,
                    ease: 'Power3'
                });
                let timeline = this.tweens.createTimeline({});
                timeline.add({
                    targets: this.scoreFxStar,
                    x: {value:"+="+this.scoreContainer.width, duration:500, ease: "Power3"}
                });
                timeline.add({
                    targets: [this.scoreFxBar,this.scoreFxStar,this.containerWhiteFx],
                    alpha: 0,
                    duration: 250,
                    ease: 'Expo.easeOut'
                });
                timeline.play();
                }
            }
        }else{
            this.sound.play('wrong');
        }

        //Animate Next Question Button
        if(this.nextQuestionButtonPosition){
            Phaser.Actions.SetXY(this.nextQuestionButton!.group.getChildren(),this.nextQuestionButtonPosition.x,this.nextQuestionButtonPosition.y);
        }else{
            console.error('nextButtonPosition is null');
        }
        Phaser.Actions.SetVisible(this.nextQuestionButton!.group.getChildren(),true);
        this.nextQuestionButton!.sprite.setInteractive();
        this.nextQuestionButtonActive = true;
    }

    showNextQuestion(){
        this.viewModel.nextQuestion();
        if(this.viewModel.isQuizDone()){
            return;
        }
        if(this.gameManager.cbnGameConfig!.gameType != GameType.daily)
        {
            //Remove missing blanks and create them again.
            if(this.missingBlankSpriteGroup){
                this.missingBlankSpriteGroup.forEach(element => {
                    if(element){
                    element.destroy();
                    }
                });
            }
            if(this.missingBlankTextGroup){
                this.missingBlankTextGroup.forEach(element => {
                    if(element){
                    element.destroy();
                    }
                });
            }
            this.createMissingBlanks();
            this.layoutMissingBlanks();
            if(this.timerProgressBar){
                this.timerProgressBar.setVisible(true);
            }
            //Enable Choice Buttons
            if(this.answers){
                for (let index = 0; index < this.answers.length; index++) {
                    const element:Button = this.answers[index];
                    element.sprite.setTexture(this.wordTexture!);
                    element.sprite.setInteractive();
                    Phaser.Actions.SetVisible(element.group.getChildren(),true);
                }
            }
            //Update Quiz View
            this.updateQuizView();
            //Resume Time if quiz is not done
            if(this.viewModel.isQuizDone()==false){
                this.timerActive = true;
                this.scene.resume(undefined!);
            }
            //Disable nextQuestionButton
            Phaser.Actions.SetVisible(this.nextQuestionButton!.group.getChildren(),false);
            
            this.nextQuestionButtonActive = false;
            this.nextQuestionButton!.sprite.setTexture('next_question_button');
        }
        this.input.disable(this.nextQuestionButton!.sprite);
    }

    updateQuizView(){
        if(this.viewModel.isQuizDone()==false){
            this.updateScore();
            this.updateRound();
            this.updateLives();
            this.updateQuizTimer();

            this.updateQuestion();
            this.updateMissingBlanks();
            this.updateChoices();
        }
    }

    updateQuestion(){
        if(this.questionText){
            let word = this.viewModel.getCurrentQuestion();
            if(word.length >320) {
                word = word.substring(0,320) + '...';
            }
            this.questionText.setText(word);
        }
    }
    updateMissingBlanks(markMissedLetters:boolean=false){
        let answer = this.viewModel.getCurrentQuestionAnswerString();
        let answerProgress = this.viewModel.getQuestionMissingBlankProgressString();
        let text:string;
        for (let index = 0; index < answerProgress.length; index++) {
            const element = answerProgress[index];
            if(element == ' '){
                //Do nothing
            }else if(IsLetter(answer[index]) == false || element != '#'){
                if(this.missingBlankTextGroup && this.missingBlankTextGroup[index]){
                    text = (IsLetter(answer[index]) == false ? answer[index] : element);
                    this.missingBlankTextGroup[index]!.setText(text.toUpperCase());
                    this.missingBlankTextGroup[index]!.setVisible(true);
                }
                if(this.missingBlankSpriteGroup && this.missingBlankSpriteGroup[index]){
                    this.missingBlankSpriteGroup[index]!.setTexture(this.scaleManager.isOrientationLandscape() ? 'lan_answer_on' : 'por_answer_on');
                }
            }else if(element == '#'){
                if(markMissedLetters){
                    if(this.missingBlankTextGroup && this.missingBlankTextGroup[index]){
                        text = answer[index];
                        this.missingBlankTextGroup[index]!.setText(text.toUpperCase());
                        this.missingBlankTextGroup[index]!.setVisible(true);
                    }
                    if(this.missingBlankSpriteGroup && this.missingBlankSpriteGroup[index]){
                        this.missingBlankSpriteGroup[index]!.setTexture(this.scaleManager.isOrientationLandscape() ? 'lan_answer_lose' : 'por_answer_lose');
                    }
                }else{
                    if(this.missingBlankTextGroup && this.missingBlankTextGroup[index]){
                        this.missingBlankTextGroup[index]!.setText('');
                        this.missingBlankTextGroup[index]!.setVisible(false);
                    }
                    if(this.missingBlankSpriteGroup && this.missingBlankSpriteGroup[index]){
                        this.missingBlankSpriteGroup[index]!.setTexture(this.scaleManager.isOrientationLandscape() ? 'lan_answer_off' : 'por_answer_off');
                    }
                }
            }
        }
    }
    
    layoutMissingBlanks(){

        if(this.viewModel.isQuizDone()){
            return;
        }

        let answer = this.viewModel.getCurrentQuestionAnswerString();
        let wordPerLine = this.missingBlankWordPerLine;
        let xOffset = 100;
        let yOffset = 100;
        let sprite:Phaser.GameObjects.Sprite|null;
        let text:Phaser.GameObjects.Text|null;
        let basePosition:Phaser.Math.Vector2 = this.missingBlanksPosition!;
        let targetPosition:Phaser.Math.Vector2;
        let targetScale:Phaser.Math.Vector2;
        let prevElement:string|null = null;
        let row;
        let column;


        let defaultColumnCount = this.scaleManager.isOrientationLandscape() ? 10 : 6;
        let defaultRowCount = this.scaleManager.isOrientationLandscape() ? 2 : 3;

        let longestWord = answer.split(' ').sort(function(a,b){
            return b.length - a.length;
        })[0];
        let maxWordLength = longestWord.length;
        let scale = Math.max(answer.length / (defaultColumnCount * defaultRowCount),1);
        scale = Math.sqrt(answer.length) / (Math.sqrt(defaultColumnCount) * Math.sqrt(defaultRowCount));
        let scaledColumnCount = Math.ceil(defaultColumnCount * scale);
        if(scaledColumnCount<maxWordLength){
            //scale = answer.length / (maxWordLength * defaultRowCount);
            //scale = 
            scaledColumnCount = maxWordLength;
            scale = maxWordLength / defaultColumnCount;
        }
        let scaledRowCount = Math.ceil(defaultRowCount * scale);
        wordPerLine = scaledColumnCount;
        console.log('Wordperline:'+wordPerLine);
        //Set Scale
        let foldedInWhitespaceAnswerRowLength =  Fold(answer,wordPerLine,true).length;
        targetScale = new Phaser.Math.Vector2(1,1);
        let scaledRows = Math.ceil(answer.length / scaledColumnCount);
        let newScale = 1 / (scale * (foldedInWhitespaceAnswerRowLength / scaledRows));
        targetScale.x = Math.min(newScale,1);
        targetScale.y = Math.min(newScale,1);

        xOffset *= targetScale.x;
        yOffset *= targetScale.y;

        //Set Centering vars
        let center = true;
        let totalRows = Math.ceil(answer.length/wordPerLine);
        let centerXOffset = ((wordPerLine-1) * xOffset/2);
        let centerYOffset = (foldedInWhitespaceAnswerRowLength * yOffset/2);
        let indexWordOffset = 0;

        let rowCenterOffsets:number[] = []; //
        let columnCount:number = 0;
        let rowGroup:number[] = [];
        for (let index = 0; index < answer.length; index++) {
            const element = answer[index];

            let endOfSentence:boolean = false;
            if(element == ' '){
                let nextWordLength = 0;
                do{
                    if(index+nextWordLength+1 < answer.length && answer[index+nextWordLength+1] != ' '){
                        nextWordLength++;
                    }
                }while(index+nextWordLength+1 < answer.length && answer[index+nextWordLength+1] != ' ');
                let row = (Math.floor((index + indexWordOffset) / wordPerLine));
                
                let nextWordLetterCutoffIndex = ( row + 1 ) * wordPerLine;
                let nextWordEndLetterIndex = (index + indexWordOffset +nextWordLength+1);
                if(Math.floor((nextWordEndLetterIndex) / wordPerLine) > row){
                    let nextWordCutoffLength = (nextWordEndLetterIndex - nextWordLetterCutoffIndex);
                    let trimmedWordLength =  nextWordLength - nextWordCutoffLength;
                    indexWordOffset += trimmedWordLength;
                    endOfSentence = true;
                }
            }
            targetPosition = new Phaser.Math.Vector2(basePosition.x,basePosition.y);
            column = ((index + indexWordOffset) % wordPerLine);
            
            if(column == 0 && index!=0){
                //console.log('Column:'+columnCount);
                for (let j = 0; j < rowGroup.length; j++) {
                    const element2 = rowGroup[j];
                    let offset = (wordPerLine - columnCount) * xOffset/2;
                    sprite = this.missingBlankSpriteGroup![element2];
                    Phaser.Actions.IncX([sprite!],offset);
                    text = this.missingBlankTextGroup![element2];
                    Phaser.Actions.IncX([text!],offset);
                }
                columnCount = 0;
                rowGroup = [];
                //rowGroup.push(index);
            }
            if(!endOfSentence){
                columnCount++;
                //console.log('ColumnCount:'+columnCount + ' Letter:'+element);
                if(element != ' '){
                    rowGroup.push(index);
                }
            }

            row = (Math.floor((index + indexWordOffset) / wordPerLine));
            targetPosition.x += column * xOffset;
            targetPosition.y += row * yOffset;
            if(center){
                targetPosition.x += - centerXOffset;
                targetPosition.y += - centerYOffset;
            }

            if(this.missingBlankSpriteGroup && this.missingBlankSpriteGroup[index]){
                sprite = this.missingBlankSpriteGroup[index];
                if(sprite){
                    sprite.setPosition(targetPosition.x,targetPosition.y);
                    sprite.setScale(targetScale.x,targetScale.y);
                }
            }
            if(this.missingBlankTextGroup && this.missingBlankTextGroup[index]){
                text = this.missingBlankTextGroup[index];
                if(text){
                    text.setPosition(targetPosition.x,targetPosition.y);
                    text.setScale(targetScale.x,targetScale.y);
                }
            }

            if(index == answer.length -1){
                //rowGroup.push(index);
                for (let j = 0; j < rowGroup.length; j++) {
                    const element2 = rowGroup[j];
                    let offset = (wordPerLine - columnCount) * xOffset/2;
                    sprite = this.missingBlankSpriteGroup![element2];
                    Phaser.Actions.IncX([sprite!],offset);
                    text = this.missingBlankTextGroup![element2];
                    Phaser.Actions.IncX([text!],offset);
                }
            }
        }
        
    }

    createMissingBlanks(){
        if(this.viewModel.isQuizDone()){
            return;
        }
        let position = this.scaleManager.getRelativePosition(0.0,0.5);
        let sprite:Phaser.GameObjects.Sprite;
        let text:Phaser.GameObjects.Text;
        let spriteGroup:(Phaser.GameObjects.Sprite|null)[] = [];
        this.missingBlankSpriteGroup = spriteGroup;
        let textGroup:(Phaser.GameObjects.Text|null)[] = [];
        this.missingBlankTextGroup = textGroup;
        let answer = this.viewModel.getCurrentQuestionAnswerString();
        let missingBlankXOffset = 100;
        let missingBlankYOffset = 100;
        let style = { fontFamily: 'Exo Medium', fontSize:64, color: '#FFFFFF',align: 'center'};
        for (let index = 0; index < answer.length; index++) {
            const element = answer[index];
            if(element == ' '){
                //Do nothing
                spriteGroup.push(null);
                textGroup.push(null);
            }else if(IsLetter(element)){
                //let answerX = answerx
                sprite = this.add.sprite(position.x + (index * missingBlankXOffset),position.y, this.scaleManager.isOrientationLandscape() ? 'lan_answer_off' : 'por_answer_off');
                spriteGroup.push(sprite);
                text = this.add.text(position.x + (index * missingBlankXOffset),position.y,'',style);
                text.setVisible(false);
                text.setOrigin(0.5);
                textGroup.push(text);
            }else{
                sprite = this.add.sprite(position.x + (index * missingBlankXOffset),position.y, this.scaleManager.isOrientationLandscape() ? 'lan_answer_on' : 'por_answer_on');
                spriteGroup.push(sprite);
                text = this.add.text(position.x + (index * missingBlankXOffset),position.y,element,style);
                text.setOrigin(0.5);
                textGroup.push(text);
            }
        }
        //this.layoutMissingBlanks();
    }

    updateScore(){
        if(this.score){
            this.score.setText(this.viewModel.getCurrentScore().toString());
        }
    }

    updateRound(){
        if(this.round){
            this.round.setText(this.viewModel.getCurrentRoundNumber().toString());
        }
    }

    updateChoices(){
        if(this.answers){
            //console.log(this.answers);
            for (let index = 0; index < this.answers.length; index++) {
                const element = this.answers[index];
                let word = this.viewModel.getCurrentQuestionLetterChoiceStrings()[index];
                if(word){
                    if(word.length >60) {
                        word = word.substring(0,60) + '...';
                    }
                    element.text.setText(word.toUpperCase());
                    if(this.nextQuestionButtonActive==false){
                        Phaser.Actions.SetVisible(element.group.getChildren(),true);
                        element.sprite.setInteractive();
                    }
                }else{
                    Phaser.Actions.SetVisible(element.group.getChildren(),false);
                    this.input.disable(element.sprite);
                }
            }
        }
    }

    updateLives(){
        if(this.lifeGroup == null) return;
        let array = this.lifeGroup;
        for (let index = 0; index < array!.length; index++) {
            let texture = this.viewModel.getCurrentLife() > index ? 'gfx_life_on' : 'gfx_life_off';
            array![index].setTexture(texture);
        }
    }

    updateQuizTimer(){
        if(this.timerProgressBar){
            this.updateProgressBar(this.viewModel.getTimerProgress());
        }
    }

    updateProgressBar(value){
        if(this.progressBarWidth! > 960)  this.progressBarWidth = 960;
        this.timerProgressBar!.clear();
        this.timerProgressBar!.fillStyle(this.progressBarColor, 1);
        this.timerProgressBar!.fillRect(this.progressBarPosition!.x, this.progressBarPosition!.y - ((this.progressBarHeight!)/2), this.progressBarWidth! * value, this.progressBarHeight!);
        this.progressBarValue = value;

        if(this.timerCounter)
        {
            var minutes = Math.floor(Math.round(this.viewModel!.getGameTimeRemaining()) / 60);
            var seconds = Math.round(this.viewModel!.getGameTimeRemaining()) - minutes * 60;
    
            var timeLeft;
            if(seconds.toString().length == 1)
            {
                timeLeft = minutes + ":0" + seconds;
            }
            else timeLeft = minutes + ":" + seconds;
            
            this.timerCounter!.setText(timeLeft);
        }
        
    }

    onPauseScene(){
        if(this.pauseScene.open==false && this.htpScene.open==false){
            this.timerActive = false;
            this.scene.pause(undefined!);
            this.pauseScene.startOpen();
        }
    }

    onUnpauseScene(){
        if(this.nextQuestionButtonActive==false){
            this.timerActive = true;
        }
        this.scene.resume(undefined!);
    }

    onEndQuiz(){
        console.log(`Ending Quiz!`);
        if(this.preloaderUIScene){
            this.scene.remove(this.preloaderUIScene.gizmoScene);
        }
        this.scene.remove(this.pauseScene.scene.settings.key);
        if(this.htpScene.scene) this.scene.remove(this.htpScene.scene.settings.key);
        let key = 'TitleScene'+Math.random();
        let nextScene = new TitleScene({key:key});
        if( this.gameManager.cbnGameConfig!.gameType != GameType.daily) {
            SceneManager.changeScene(this,nextScene);
        }
    }

    checkIfInterrupt(){
        if ((<any>window.document).webkitHidden || window.document.hidden) {
            this.onPauseScene();
        }
    }
}